import styled from "styled-components";
import PerfectScrollbar from "react-perfect-scrollbar";

export const Scrollbar = styled(PerfectScrollbar)`
  &.ps--scrolling-y {
    .ps__rail-y {
      opacity: 1 !important;
    }
  } 
  
  .ps__rail-y {
    width: ${props => props.theme.widthRatio*10}px;
    background-color: ${props => props.theme.name === 'dark' ? props.theme.palette.primary[850] : '#D0D0D0'} !important;
    border-radius: ${props => props.theme.widthRatio*6}px !important;
    
    .ps__thumb-y {
      width: ${props => props.theme.widthRatio*10}px;
      background-color: ${props => props.theme.name === 'dark' ? props.theme.palette.primary[750] : '#4B4B4B'} !important;
      right: 0 !important;
      border-radius: ${props => props.theme.widthRatio*6}px !important;
    }
  }
`;
